import React from "react";
import { MaintenancePage } from "components/organisms";
import "./MaintenanceLayout.scss";

const MaintenanceLayout: React.FC = () => {
  return (
    <section
      className="maintenance-container"
      data-testid="maintenance-section"
    >
      <div className="container" data-testid="maintenance-container">
        <MaintenancePage />
      </div>
    </section>
  );
};

export default MaintenanceLayout;
